import "core-js/modules/es.symbol";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.join";
import "core-js/modules/es.array.map";
import "core-js/modules/es.object.get-own-property-descriptor";
import "core-js/modules/es.object.keys";
import "core-js/modules/web.dom-collections.for-each";

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { defineMessages, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import * as logger from 'universal-logger';
import { withSagas } from 'decorators/Sagas';
import trackDwell from 'decorators/TrackDwell/TrackDwell';
import { decorateWith } from 'helpers/decorator';
import { deepExtract } from 'helpers/deep';
import { isAbsent, isEmpty } from 'helpers/verify';
import { selectIsClient } from 'redux/modules/device';
import { selectMsaId } from 'redux/modules/features/homepage';
import { msas, msaCreditStatById, plansByMsa, promotionByAlias } from 'redux/saga/entities/bound';
import { msaByIdentifier } from 'redux/saga/selectors/msas';
import { PlanSelection } from './PlanSelection';
import { loadSaga, watchSaga, loadCardData, selectPlan } from './plan-selection.saga';
var messages = defineMessages({
  ctaSelect: {
    id: 'plan-selection.card.cta.select',
    defaultMessage: 'Select'
  },
  firstMonthOfferNote: {
    id: 'plan-selection.card.first-month-offer-note',
    defaultMessage: '~~{originalPrice}~~ first month'
  },
  planDetails: {
    id: 'plan-selection.card.plan-details',
    defaultMessage: 'Includes __{creditsPerCycle, number}&nbsp;credits__ to book __{minClassEstimate, number}&nbsp;-&nbsp;{maxClassEstimate, number}&nbsp;classes__'
  },
  standardPlanNote: {
    id: 'plan-selection.card.standard-plan-note',
    defaultMessage: 'per month'
  }
});

function formatPrice(intl, msa, price, withFractionDigits) {
  return intl.formatNumber(Math.max(0, price), _objectSpread({
    style: 'currency',
    currency: msa.currency_code
  }, !withFractionDigits && {
    maximumFractionDigits: 0,
    minimumFractionDigits: 0
  }));
}

function formatPlanDetails(intl, plan) {
  var creditsPerCycle = plan.credits_per_cycle,
      maxClassEstimate = plan.max_class_estimate,
      minClassEstimate = plan.min_class_estimate;

  if ([creditsPerCycle, maxClassEstimate, minClassEstimate].some(isAbsent)) {
    logger.warn("Incomplete plan data for plan [".concat(plan.id, "]"));
    return '';
  } // NOTE: non-breaking elements to ensure proper formatting


  return intl.formatMessage(messages.planDetails, {
    creditsPerCycle: creditsPerCycle,
    minClassEstimate: minClassEstimate,
    maxClassEstimate: maxClassEstimate
  });
}

function buildCustomCards(intl, msa, customCards) {
  return customCards.map(function (customCard) {
    var cardType = customCard.cardType || {};
    var features = customCard.features || [];
    return _objectSpread({
      callout: formatPrice(intl, msa, customCard.price),
      calloutNote: customCard.priceTerm || '',
      cta: deepExtract('cta.copy', customCard) || intl.formatMessage(messages.ctaSelect),
      details: customCard.details || features.map(function (feature) {
        return "* ".concat(feature);
      }).join('\n'),
      tag: deepExtract('tag.copy', customCard, '')
    }, cardType.type === 'fullFare' && {
      itemId: cardType.planId,
      type: 'plan'
    }, cardType.type === 'msaOffer' && {
      itemId: cardType.msaOfferId,
      type: 'offer'
    });
  });
}

function buildPlanCards(intl, msa, plans) {
  return plans.map(function (plan) {
    return {
      callout: formatPrice(intl, msa, plan.price),
      calloutNote: intl.formatMessage(messages.standardPlanNote),
      cta: intl.formatMessage(messages.ctaSelect),
      details: formatPlanDetails(intl, plan),
      itemId: plan.id,
      type: 'plan'
    };
  });
}

function buildPromotionCards(intl, msa, offers) {
  return offers.map(function (offer) {
    var originalPrice = formatPrice(intl, msa, offer.recurring_plan.price);
    var isSingleMonth = offer.initial_duration_formatted === '1 month'; // Note: backwards compatabile for non-required price terms

    var calloutNote = deepExtract('content.card.price_terms', offer) || isSingleMonth && intl.formatMessage(messages.firstMonthOfferNote, {
      originalPrice: originalPrice
    }) || '';
    return {
      callout: formatPrice(intl, msa, offer.price),
      calloutNote: calloutNote,
      cta: deepExtract('content.card.cta_copy', offer) || intl.formatMessage(messages.ctaSelect),
      details: formatPlanDetails(intl, offer.initial_plan),
      itemId: offer.id,
      tag: deepExtract('content.card.tag', offer, ''),
      type: 'offer'
    };
  });
}

function buildCards(state, intl, msa) {
  var plansModuleConfig = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  if (isEmpty(msa)) {
    return [];
  } else if (plansModuleConfig.type === 'checkoutPlansModuleType') {
    var plans = plansByMsa.data(state, msa.id);
    return buildPlanCards(intl, msa, plans || []);
  } else if (plansModuleConfig.type === 'promotionPlansModuleType') {
    var key = promotionByAlias.defaultKey(null, plansModuleConfig.promotionAlias, msa.id);
    var promotion = promotionByAlias.data(state, key) || {};
    return buildPromotionCards(intl, msa, promotion.offers || []);
  } else if (plansModuleConfig.type === 'pricingCardsPlansModuleType') {
    return buildCustomCards(intl, msa, plansModuleConfig.purchaseCards || []);
  }

  return [];
}

export var mapStateToProps = function mapStateToProps(state, props) {
  var msaId = selectMsaId(state);
  var msa = msaByIdentifier(msas.data(state), msaId) || {};
  var msaCreditStat = msaCreditStatById.data(state, msaId) || {};
  return {
    cards: props.cards || buildCards(state, props.intl, msa, props.plansModuleType),
    creditsPerClassAverage: msaCreditStat.average_credits_per_class,
    isClient: selectIsClient(state),
    plansModuleConfig: props.plansModuleType,
    subtitleStyle: props.subtitleStyle || 'subtle'
  };
};
export var mapDispatchToProps = {
  loadCardData: loadCardData,
  selectPlan: selectPlan
};
export var PlanSelectionContainer = decorateWith(trackDwell, withSagas({
  load: loadSaga,
  watch: watchSaga
}), connect(mapStateToProps, mapDispatchToProps), injectIntl)(PlanSelection);